import React, { Component } from "react";
import { observer } from "mobx-react";
import ModalStore from "../../../stores/ModalStore";
import LoginStore from "../../../stores/LoginStore";
import SignInFormContainer from "./SignInFormContainer";

const logo = require("../../../../../assets/images/landings/home-logo.svg");

interface Props {
  showSignInSidebar: boolean;
  redirectUrl: string;
  handleHideSignInSideBar: () => void;
  loginUser: (e: React.MouseEvent<HTMLElement>) => void;
  modalStore: ModalStore;
  loginStore: LoginStore;
}

class SignInSidebar extends Component<Props, {}> {
  render() {
    const {
      showSignInSidebar,
      redirectUrl,
      handleHideSignInSideBar,
      modalStore,
      loginStore,
      loginUser,
    } = this.props;

    const panelClass = showSignInSidebar
      ? "signin-panel is-open"
      : "signin-panel";
    const backdropClass = showSignInSidebar
      ? "signin-backdrop is-open"
      : "signin-backdrop";

    return (
      <div className="signin-panel-shell" aria-hidden={!showSignInSidebar}>
        <div
          className={backdropClass}
          onClick={() => handleHideSignInSideBar()}
        ></div>
        <aside
          className={panelClass}
          id="sign_in_sidebar"
          role="dialog"
          aria-modal="true"
          aria-labelledby="signin-title"
          tabIndex={-1}
        >
          <div className="signin-inner">
            <div className="signin-top">
              <a className="signin-mark" href="/" aria-label="42courses home">
                <img src={logo} alt="42courses" />
              </a>
              <button
                type="button"
                className="signin-close"
                id="closeNav"
                onClick={() => handleHideSignInSideBar()}
                aria-label="Close sign in panel"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M6 6l12 12M18 6L6 18" />
                </svg>
              </button>
            </div>
            <SignInFormContainer
              key={showSignInSidebar ? "signin-open" : "signin-closed"}
              redirectUrl={redirectUrl}
              loginStore={loginStore}
              loginUser={loginUser}
              modalStore={modalStore}
            />
          </div>
        </aside>
      </div>
    );
  }
}

export default observer(SignInSidebar);
